/**
 * Checks if an object has no properties.
 *
 * @param  {Object} obj The object to check
 * @return {Boolean} True if the object is empty
 *
 * @throws {Error} If `obj` is not an object
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * isEmptyObject({}); // true
 * isEmptyObject({ foo: `bar` }); // false
 * isEmptyObject({ foo: null }); // false
 */
const isEmptyObject = (obj) => {
  if (typeof obj !== `object`) {
    throw new Error(
      `isEmptyObject was provided with an arg that wasn't an object`,
    );
  }

  return Object.keys(obj).length === 0;
};

/** @component */
export default isEmptyObject;
